var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#FF8F2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51025 10.2031C9.59375 8.09717 11.0317 6.50146 13.7222 6.50146C16.1714 6.50146 17.8228 7.95801 17.8228 9.94336C17.8228 11.3813 17.0991 12.3926 15.8745 13.1255C14.6777 13.8306 14.3345 14.3223 14.3345 15.2778V15.8438H12.4141L12.4048 15.1016C12.3584 13.7935 12.9243 12.9585 14.1953 12.1978C15.3179 11.5205 15.7168 10.9824 15.7168 10.0269C15.7168 8.97852 14.8911 8.2085 13.6201 8.2085C12.3398 8.2085 11.5142 8.97852 11.4307 10.2031H9.51025ZM13.3882 20.1392C12.7109 20.1392 12.1729 19.6196 12.1729 18.9424C12.1729 18.2651 12.7109 17.7456 13.3882 17.7456C14.084 17.7456 14.6128 18.2651 14.6128 18.9424C14.6128 19.6196 14.084 20.1392 13.3882 20.1392Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.6f02b9a62e5de36059ee20646973c410.svg";
export { ForwardRef as ReactComponent };